import React, { useState, useEffect } from "react";
import { SnackbarProvider, closeSnackbar } from 'notistack';
import { Routes, Route } from "react-router-dom";

// Components
import Login from "./components/login.component";
import ResponsiveLayout from "./components/ResponsiveLayout";
import { ErrorProvider, ErrorBoundary } from "./components/ErrorHandler";
import AuthService from "./services/AuthService";

// Pages
import Dashboard from "./pages/dashboard";
import { Secrets } from "./pages/secrets";
import { Sections } from "./pages/sections";
import { Clients } from "./pages/clients";
import ErrorPage from "./pages/error";

const App = () => {
  const [currentUser, setCurrentUser] = useState(AuthService.CurrentUser());
  const [title, setTitle] = useState("Dashboard");

  // Verificar autenticación al cargar
  useEffect(() => {
    const user = AuthService.CurrentUser();
    if (user) {
      setCurrentUser(user);
    }
  }, []);

  // Si no hay usuario autenticado, mostrar login
  if (!currentUser) {
    return (
      <ErrorBoundary>
        <ErrorProvider>
          <SnackbarProvider 
            maxSnack={3}
            anchorOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}
            dense
            preventDuplicate
            autoHideDuration={4000}
            action={(snackbarId) => (
              <button
                onClick={() => closeSnackbar(snackbarId)}
                className="text-white hover:text-gray-200 ml-2"
                style={{ background: 'none', border: 'none', cursor: 'pointer' }}
              >
                ✕
              </button>
            )}
          >
            <Login onLoginSuccess={() => setCurrentUser(AuthService.CurrentUser())} />
          </SnackbarProvider>
        </ErrorProvider>
      </ErrorBoundary>
    );
  }

  return (
    <ErrorBoundary>
      <ErrorProvider>
        <SnackbarProvider 
          maxSnack={3}
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          dense
          preventDuplicate
          autoHideDuration={4000}
          action={(snackbarId) => (
            <button
              onClick={() => closeSnackbar(snackbarId)}
              className="text-white hover:text-gray-200 ml-2"
              style={{ background: 'none', border: 'none', cursor: 'pointer' }}
            >
              ✕
            </button>
          )}
        >
          <ResponsiveLayout title={title} setTitle={setTitle}>
            <Routes>
              <Route 
                path="/" 
                element={<Dashboard setTitleProps={setTitle} />} 
              />
              <Route 
                path="/secrets" 
                element={<Secrets setTitleProps={setTitle} />} 
              />
              <Route 
                path="/sections" 
                element={<Sections setTitleProps={setTitle} />} 
              />
              <Route 
                path="/clients" 
                element={<Clients setTitleProps={setTitle} />} 
              />
              <Route 
                path="*" 
                element={<ErrorPage setTitleProps={setTitle} />} 
              />
            </Routes>
          </ResponsiveLayout>
        </SnackbarProvider>
      </ErrorProvider>
    </ErrorBoundary>
  );
};

export default App;